const config = {
  name: 'crm-c52dc59039386c5d',
  rowKey: 'bizOpId',
  cacheDisabled: false,
  cacheType: "REMOTE",
  columns: [
    {
      title: '线索ID',
      dataIndex: 'clueId',
      width: 200,
      fixed: 'left',
      render: 'clueIdRender',
    },
    {
      title: '商机ID',
      dataIndex: 'id',
      width: 200,
      fixed: 'left',
      render: 'trackIdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 180,
      ellipsis: true,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 160,
      render: 'checkPhone',
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '公司',
      dataIndex: 'orgName',
      width: 160,
    },
    {
      title: '需求标签',
      dataIndex: 'bizTypeName',
      width: 160,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '创建日期',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '飞单次数',
      dataIndex: 'invalidCount',
      width: 120,
    },
    {
      title: '最近一次飞单原因',
      dataIndex: 'reasonName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 150,
      render: 'operationCell',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'clueId',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'id',
      label: '商机ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'bizType',
      label: '需求标签',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'typeListArr',
      allowClear: true,
    },
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      itemType: 'number',
      label: '客户电话',
    },
    {
      name: 'orgId',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      allowClear: true,
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'buildingId',
      label: '楼盘名称',
      key: 'id',
      labelKey: 'name',
      itemType: 'select',
      data: 'buildingId',
      notFoundContent: '请选择公司或暂无数据',
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'firstDate',
      label: '首访日期',
      itemType: 'autoDate',
      showTime: true,
    },
    {
      name: 'createDate',
      label: '创建日期',
      itemType: 'autoDate',
      showTime: true,
    },
  ],
  batchActions: [
    {
      label: '批量领取',
      type: 'primary',
      render: 'allReceive',
    },
    {
      label: '批量指定分配',
      type: 'primary',
      render: 'assignDesignAll',
    },
  ],
}
export default config
